import ComplaintsScreen from './components/ComplaintsScreen'

export default {
  path: '/reclamaciones',
  name: 'Complaints',
  component: ComplaintsScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Complaints/index.js